import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';

// STYLES
import { Wrapper, ButtonStyled, Container } from './styles';
import ReactHtml from '@/components/ReactHtml/ReactHtml';

const CollapsableContainer = ({
  disableShadow,
  title,
  open,
  handleCollapse,
  children,
  collapseProps,
}) => {
  return (
    <Wrapper
      className={clsx('collapsable-container', !disableShadow && 'collapsable-container--shadow')}
    >
      <ButtonStyled
        className="collapsable-container__button"
        disableElevation
        disableFocusRipple
        fullWidth
        onClick={handleCollapse}
      >
        <Typography variant="h6">
          <ReactHtml component="span">{title}</ReactHtml>
        </Typography>
        <i className={open ? 'icon-minus' : 'icon-plus'} />
      </ButtonStyled>
      <Collapse in={open} {...collapseProps}>
        <Container className="collapsable-container__container">{children}</Container>
      </Collapse>
    </Wrapper>
  );
};

CollapsableContainer.defaultProps = {
  disableShadow: false,
  collapseProps: {},
};

CollapsableContainer.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleCollapse: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  disableShadow: PropTypes.bool,
  collapseProps: PropTypes.object,
};

export default React.memo(CollapsableContainer);
